import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { UserService } from 'src/app/services/user.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-confirm-pse',
  templateUrl: './confirm-pse.component.html',
  styleUrls: ['./confirm-pse.component.css']
})
export class ConfirmPseComponent implements OnInit {
  public transaccion
  constructor(
    private _route: ActivatedRoute,
    private router: Router,
    private _userService: UserService,
    private spinner: NgxSpinnerService
  ) { }

  ngOnInit(): void {
    this.spinner.show()
    let id = this._route.snapshot.paramMap.get('id')
    this.getEstado(id)
  }

  getEstado(id) {
    let data = {
      factura: id
    }

    this._userService.httpPost('confirm_pse', data).subscribe(resp => {
      console.log(resp)
      this.transaccion = resp
      if (this.transaccion.data.estado == 'Aceptada') {
        Swal.fire({
          icon: 'success',
          title: this.transaccion.text_response,
          text: this.transaccion.data.respuesta
        }).then(resp => {
          this.router.navigate(['/login'])
        })
      }else if (this.transaccion.data.estado == 'Rechazada') {
        Swal.fire({
          icon: 'error',
          title: this.transaccion.text_response,
          text: this.transaccion.data.respuesta
        }).then(resp => {
          this.router.navigate(['/login'])
        })
      }
      this.spinner.hide()
    })
  }
}
